(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mons-cyber"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mons-cyber')) customElements.define('mons-cyber',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.start=Date.parse(this.dataset.start);this.end=Date.parse(this.dataset.end);this.words=JSON.parse(this.querySelector('[data-mc-words]').textContent);this.dialog=this.querySelector('dialog');this.opener=null;
 this.open=(automatic=false)=>{clearTimeout(this.autoCloseTimer);if(Date.now()>=this.end)return;this.opener=document.activeElement;this.dialog.showModal();this.querySelector('[data-mc-close]').focus();if(automatic===true)this.autoCloseTimer=setTimeout(()=>this.close(),5000)};
 this.close=()=>{clearTimeout(this.autoCloseTimer);this.dialog.close();this.opener?.focus();try{sessionStorage.setItem('mons.cyber.2026.seen','1')}catch{}};
 this.querySelector('[data-mc-open]').addEventListener('click',()=>this.open(false));this.querySelector('[data-mc-close]').addEventListener('click',this.close);this.dialog.addEventListener('cancel',()=>{clearTimeout(this.autoCloseTimer);try{sessionStorage.setItem('mons.cyber.2026.seen','1')}catch{}});
 this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.close()}});
 this.querySelector('[data-mc-discover]').addEventListener('click',()=>{this.close();const target=document.getElementById('MonsFavoriteSelection');target?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});target?.focus({preventScroll:true})});
 this.querySelector('[data-mc-copy-code]').addEventListener('click',async e=>{try{await navigator.clipboard.writeText('CYBERMONS');e.target.textContent=this.words.copied}catch{e.target.textContent='CYBERMONS'}});
 this.tick();this.timer=setInterval(()=>this.tick(),1000);let seen=false;try{seen=sessionStorage.getItem('mons.cyber.2026.seen')==='1'}catch{} if(!seen&&Date.now()<this.end&&!window.Shopify?.designMode)this.showTimer=setTimeout(()=>{if(!document.querySelector('dialog[open]'))this.open(true)},1800);
 }
 tick(){const now=Date.now();if(now>=this.end){this.hidden=true;if(this.dialog.open)this.dialog.close();clearInterval(this.timer);return}this.hidden=false;const active=now>=this.start;const total=Math.max(0,Math.floor(((active?this.end:this.start)-now)/1000));this.querySelector('[data-mc-hours]').textContent=String(Math.floor(total/3600)).padStart(2,'0');this.querySelector('[data-mc-minutes]').textContent=String(Math.floor(total/60)%60).padStart(2,'0');this.querySelector('[data-mc-seconds]').textContent=String(total%60).padStart(2,'0');this.querySelector('[data-mc-apply]').hidden=!active;if(this.phase!==active){this.phase=active;for(const [sel,key] of [['heading',active?'count_live':'count_soon'],['copy',active?'count_copy_live':'count_copy'],['title',active?'live':'soon'],['tagline',active?'tagline_live':'tagline'],['discover',active?'cta_live':'cta']])this.querySelector('[data-mc-'+sel+']').textContent=this.words[key]}}
 disconnectedCallback(){clearInterval(this.timer);clearTimeout(this.showTimer);clearTimeout(this.autoCloseTimer)}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mons-favorites"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.MonsFavorites) return;
  const KEY = 'mons.favorites.v1';
  const LIMIT = 100;
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,180}$/.test(value);
  const cleanImage = value => { try { const url = new URL(value, location.origin); return url.protocol === 'https:' ? url.href : ''; } catch { return ''; } };
  const clean = list => Array.isArray(list) ? [...new Map(list.filter(x => x && validHandle(x.handle)).map(x => [x.handle, {handle:x.handle,title:String(x.title || x.handle).slice(0,240),image:cleanImage(x.image || '')}])).values()].slice(0,LIMIT) : [];
  let items = [], storageOK = true, generation = 0, previousFocus = null, catalogPromise;
  const host = () => document.querySelector('[data-mons-favorites]');
  const messages = () => JSON.parse(host()?.querySelector('[data-wish-messages]')?.textContent || '{}');
  let toastTimer;
  const say = message => { const area = host()?.querySelector('[data-wish-status]'); if(area) { area.textContent = message || ''; clearTimeout(toastTimer); toastTimer=setTimeout(()=>{area.textContent='';},5000); } };
  function read() { try { items = clean(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch { items = []; storageOK = false; } }
  function sync() {
    document.querySelectorAll('[data-wish-toggle]').forEach(button => {
      const saved = items.some(p => p.handle === button.dataset.wishHandle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? messages().remove : messages().add}: ${button.dataset.wishTitle || ''}`);
      button.classList.toggle('is-saved',saved);
    });
    document.querySelectorAll('[data-wish-count]').forEach(el => { el.textContent = String(items.length); el.hidden = items.length === 0; });
  }
  function commit(next) {
    try { localStorage.setItem(KEY,JSON.stringify(next)); items = next; storageOK = true; sync(); return true; }
    catch { storageOK = false; say(messages().storage_error); return false; }
  }
  function toggle(button) {
    read();
    const handle = button.dataset.wishHandle;
    if (!validHandle(handle)) return;
    const found = items.some(p => p.handle === handle);
    if (!found && items.length >= LIMIT) { say(messages().limit); return; }
    const next = found ? items.filter(p => p.handle !== handle) : [...items,{handle,title:String(button.dataset.wishTitle || handle).slice(0,240),image:cleanImage(button.dataset.wishImage || '')}];
    if (commit(next)) { say(found ? messages().removed : messages().saved); if(host()?.querySelector('dialog')?.open) render(); }
  }
  const element = (tag,text,className) => { const el=document.createElement(tag); if(text)el.textContent=text; if(className)el.className=className; return el; };
  function productURL(handle) { return (host()?.dataset.shopRoot || '/') + 'products/' + encodeURIComponent(handle); }
  async function freshProduct(handle) {
    if (host().dataset.catalog) {
      catalogPromise ||= fetch(host().dataset.catalog).then(r=>{if(!r.ok)throw Error();return r.json()});
      return (await catalogPromise)[handle] || null;
    }
    const response = await fetch(productURL(handle)+'.js',{credentials:'same-origin',signal:AbortSignal.timeout(12000)});
    if (response.status === 404) return null;
    if (!response.ok) throw Error('unavailable');
    return response.json();
  }
  async function render() {
    const version = ++generation, box = host().querySelector('[data-wish-list]'), empty = host().querySelector('[data-wish-empty]');
    box.replaceChildren(); empty.hidden = items.length > 0;
    host().querySelector('[data-wish-total]').textContent = String(items.length);
    const jobs = items.map(item => {
      const article=element('article',null,'mons-wish-item');
      if(item.image){const image=element('img');image.src=item.image;image.alt=item.title;image.loading='lazy';article.append(image);}
      const info=element('div'),link=element('a',item.title);link.href=productURL(item.handle);
      const price=element('p',messages().loading,'mons-wish-price'), remove=element('button',messages().remove);
      remove.type='button';remove.dataset.wishToggle='';remove.dataset.wishHandle=item.handle;remove.dataset.wishTitle=item.title;remove.setAttribute('aria-label',`${messages().remove}: ${item.title}`);
      info.append(link,price,remove);article.append(info);box.append(article);
      return async () => {
        try {
          const product=await freshProduct(item.handle);
          if(version!==generation)return;
          if(!product){price.textContent=messages().unavailable;link.removeAttribute('href');return;}
          link.textContent=product.title;
          const amount=Number(product.price);
          price.textContent=Number.isFinite(amount)?new Intl.NumberFormat((document.documentElement.lang === 'es' ? 'es-CL' : document.documentElement.lang) || 'es-CL',{style:'currency',currency:host().dataset.currency || 'CLP'}).format(amount/100):'';
          if(!product.available)price.append(element('span',messages().sold_out,'mons-wish-sold-out'));
        } catch { if(version===generation)price.textContent=messages().check_price; }
      };
    });
    sync();
    for(let i=0;i<jobs.length;i+=6){if(version!==generation)break;await Promise.all(jobs.slice(i,i+6).map(fn=>fn()));}
  }
  function open() {
    const dialog=host()?.querySelector('dialog');if(!dialog)return;
    read();sync();previousFocus=document.activeElement;
    if(!dialog.open)dialog.showModal();render();
    if(!storageOK)say(messages().storage_error);
  }
  document.addEventListener('click',event => {
    const toggleButton=event.target.closest('[data-wish-toggle]');
    if(toggleButton){event.preventDefault();event.stopPropagation();toggle(toggleButton);return;}
    if(event.target.closest('[data-wish-open]')){event.preventDefault();open();return;}
    if(event.target.closest('[data-wish-close]')){host()?.querySelector('dialog').close();return;}
    if(event.target===host()?.querySelector('dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
  },true);
  window.addEventListener('storage',event=>{if(event.key===KEY||event.key===null){read();sync();if(host()?.querySelector('dialog')?.open)render();}});
  function init(){
    if(!host())return;
    read();sync();
    host().querySelector('dialog').addEventListener('close',()=>{generation++;previousFocus?.focus();});
    let scheduled=false;
    new MutationObserver(records=>{if(scheduled||!records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-wish-toggle],[data-wish-count]')||n.querySelector?.('[data-wish-toggle],[data-wish-count]')))))return;scheduled=true;queueMicrotask(()=>{scheduled=false;sync();});}).observe(document.body,{childList:true,subtree:true});
  }
  window.MonsFavorites={open};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
  } catch(e) { console.error(e); }
})();

})();
